export default __webpack_public_path__ + "static/favicon-6e6aa8b195c2264fb4ca9fc2fffbea27.png";